import React, { useEffect } from 'react'
import { useColorPaletteComponent } from './useColorPaletteComponent.hook'
import { QuizQuestionWrapper } from '../../QuizQuestionWrapper'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './style.scss'
import { useLocation } from 'react-router-dom'
import { QuizType } from 'src/pages/shared'
import { IGenericObject } from 'src/types'

export const dropdownStyles = {
  control: (styles: React.CSSProperties) => ({ ...styles, backgroundColor: '#fff', paddingTop: '0px' }),
  option: (
    styles: React.CSSProperties & { ':active'?: React.CSSProperties; ':hover'?: React.CSSProperties },
    { isDisabled }: { isDisabled: boolean }
  ) => {
    return {
      ...styles,
      backgroundColor: '#fff',
      fontFamily: 'LTC Caslon',
      color: '#231F20',
      cursor: isDisabled ? 'not-allowed' : 'default',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#eb4b32',
        color: '#fff',
      },
      ':hover': {
        ...styles[':hover'],
        backgroundColor: '#eb4b32',
        color: '#fff',
      },
    }
  },
  menu: (styles: React.CSSProperties) => {
    return {
      ...styles,
      backgroundColor: '#F2F1EA',
    }
  },
}

export const ColorPaletteComponentV2 = () => {
  const {
    nextDisabled,
    handleNext,
    handleBack,
    colorPalettes,
    setPaletteSelected,
    paletteSelected,
    handleNextWithValue,
  } = useColorPaletteComponent()
  const query = new URLSearchParams(useLocation().search)

  useEffect(() => {
    const currentTempData = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}')
    const currentColorPalette = currentTempData?.colorPalette
    if (currentColorPalette) {
      setPaletteSelected(currentColorPalette)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!colorPalettes.length) {
    return <></>
  }

  const palettesToRender = colorPalettes

  return (
    <QuizQuestionWrapper
      titleStep="COLOR PALETTE"
      title="Which floral palette speaks to you?"
      subtitle=""
      nextAction={{
        onAction: handleNext,
        disabled: nextDisabled,
      }}
      backAction={{
        onAction: handleBack,
      }}
      step={1}
      total={7}
      className="quiz-guest-colors"
      showBgFlower={false}
      quizType={query.get('quizType') as QuizType}
    >
      <div className="quiz-guest-colors_flowers quiz-guest-colors-palette">
        <div className={`poppy-wedding ${paletteSelected && 'selectedPalette'}`}>
          <div className="flower-wrapper">
            {
              <>
                <div className="new-color-palette-v2">
                  {palettesToRender?.map((e, index) => {
                    const tileImageUrl = e.overviewCarousels?.[0]?.imageUrl || ''
                    // First row (4 desktop, 2 mobile) is above the fold — load
                    // eagerly so we don't slow down LCP. The rest defer until
                    // the user scrolls.
                    const isAboveFold = index < 4
                    return (
                      <div className="color-palette-item-wrapper" key={index}>
                        <div
                          className={`color-palette-item ${paletteSelected?.id === e.id ? 'selected' : ''}`}
                          onClick={() => handleNextWithValue(colorPalettes[index])}
                        >
                          {tileImageUrl && (
                            <img
                              className="color-palette-item-image"
                              src={tileImageUrl}
                              alt={e.name || 'color palette'}
                              loading={isAboveFold ? 'eager' : 'lazy'}
                              decoding="async"
                              // fetchpriority is a valid img attribute but not
                              // yet in React's typings on older versions.
                              {...(isAboveFold ? { fetchpriority: 'high' } : {})}
                            />
                          )}
                          <div className="color-showcase">
                            {Array.isArray(e.colors) &&
                              e.colors?.map((c: Record<string, any>, i: number) => (
                                <div
                                  className="style-main-color"
                                  key={`style-main-color-${i}`}
                                  style={{ backgroundColor: c.hex }}
                                ></div>
                              ))}
                          </div>
                        </div>
                        <div className="palette-name">{e.name}</div>
                      </div>
                    )
                  })}
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </QuizQuestionWrapper>
  )
}
